/** GSAP loaded on demand so auth/marketing shells stay light. */

let gsapModulePromise = null;

export function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export async function loadGsap() {
  if (!gsapModulePromise) {
    gsapModulePromise = Promise.all([
      import('gsap'),
      import('gsap/ScrollTrigger'),
      import('gsap/ScrollSmoother'),
    ]).then(([gsapMod, stMod, smootherMod]) => {
      const gsap = gsapMod.default;
      const { ScrollTrigger } = stMod;
      const { ScrollSmoother } = smootherMod;
      gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
      gsap.config({ force3D: true });
      // limitCallbacks skips callbacks fired mid-refresh; ignoreMobileResize
      // stops the mobile address bar from triggering full recalculations.
      ScrollTrigger.config({ limitCallbacks: true, ignoreMobileResize: true });
      return { gsap, ScrollTrigger, ScrollSmoother };
    });
  }
  return gsapModulePromise;
}

/** @deprecated Prefer loadGsap() — sync helper kept for gradual migration */
export function getGsap() {
  throw new Error('Use await loadGsap() — GSAP is now async to reduce unused JS.');
}
